// extracted by mini-css-extract-plugin
export var adjacentSlide = "_o9-9";
export var arrowButtonContainer = "_o9-5";
export var arrowButtonIcon = "_o9-6";
export var carouselArrowButton = "_o9-2";
export var carouselElementContainer = "_o9-1";
export var currentSlide = "_o9-8";
export var left = "_o9-3";
export var otherSlide = "_o9-a";
export var productCarouselContainer = "_o9-0";
export var right = "_o9-4";
export var sliderOverflow = "_o9-7";